module.exports = __webpack_public_path__ + "img/reset_filter.0b682dc4.svg";